import defaultTheme from './defaultTheme';
const norwegianRewardTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#8c92ac', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#8c92ac', background: '#8c92ac' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#8c92ac' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#8c92ac', border: '#8c92ac', background: '#8c92ac' }), field: {
        focus: '#8c92ac',
        label: '#8c92ac',
        icon: '#8c92ac',
    } });
export default norwegianRewardTheme;
